import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilEdit = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.41667 12.75H12.75M0.75 12.747L2.56777 12.7499C2.82739 12.7503 2.9572 12.7505 3.07937 12.7212C3.18769 12.6952 3.29125 12.6522 3.38623 12.5938C3.49337 12.528 3.58516 12.4358 3.76874 12.2514L12.4176 3.56451C12.771 3.2096 12.8588 2.66087 12.5896 2.22722C12.2642 1.70298 11.8191 1.25221 11.3011 0.917542C10.886 0.649305 10.3408 0.708053 9.99174 1.05864L1.28993 9.79868C1.11296 9.97643 1.02447 10.0653 0.960292 10.1688C0.903379 10.2605 0.86072 10.3604 0.833785 10.4651C0.803409 10.5831 0.800308 10.7088 0.794105 10.9601L0.75 12.747Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPencilEdit);
export default ForwardRef;
